import {
  createColumnHelper,
  getCoreRowModel,
  getFacetedMinMaxValues,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import PaginatedTable from '../Common/PaginatedTable';
import { HiPencilAlt, HiXCircle } from 'react-icons/hi';
import { WarrantyPartsReplaced } from '../../Models/WarrantyPartsReplaced';

export default function WarrantyPartsTable({
  data,
  editWarrantyPartsReplaceds,
  deleteWarrantyPart,
}: {
  data: WarrantyPartsReplaced[];
  editWarrantyPartsReplaceds: (labor: WarrantyPartsReplaced) => void;
  deleteWarrantyPart(labor: WarrantyPartsReplaced): void;
}) {
  const columnHelper = createColumnHelper<WarrantyPartsReplaced>();

  const columns = [
    columnHelper.accessor((row) => row.id, {
      id: 'id',
      header: '',
      cell: (info) => (
        <div className='flex justify-center gap-1'>
          <button
            type='button'
            className='buttonMain p-2'
            onClick={() => editWarrantyPartsReplaceds(info.row.original)}
          >
            <HiPencilAlt />
          </button>
          <button
            type='button'
            className='buttonCancel p-2'
            onClick={() => deleteWarrantyPart(info.row.original)}
          >
            <HiXCircle />
          </button>
        </div>
      ),
      footer: (info) => info.column.id,
      size: 35,
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.partNumber, {
      id: 'partNumber',
      header: 'Part Number',
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.quantity, {
      id: 'quantity',
      header: 'Quantity',
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.amount, {
      id: 'amount',
      header: 'Amount',
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.description, {
      id: 'description',
      header: 'Description',
      enableColumnFilter: false,
    }),
  ];

  const table = useReactTable({
    data,
    columns,
    getSortedRowModel: getSortedRowModel(),
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
    // Claim form tables hide the pager; show every row (TanStack default pageSize is 10).
    state: {
      pagination: {
        pageIndex: 0,
        pageSize: Math.max(data.length, 1),
      },
    },
  });

  return (
    <>
      <div className='w-full mx-auto overflow-x-auto'>
        <PaginatedTable
          table={table}
          dataCount={data.length}
          columnResizeMode='onChange'
          showFilters={true}
          showPagination={false}
        />
      </div>
    </>
  );
}
